export default __webpack_public_path__ + "static/media/1.c98e8e15.png";